export default __webpack_public_path__ + "static/media/logo.495338f7.png";